import React from "react";
import colors from "../../styles/colors";

export default ({ text, whiteLabelSettings }) => {
  const sectionTitle = {
    color:
      whiteLabelSettings && whiteLabelSettings.isWhiteLabel
        ? whiteLabelSettings.primaryColor
        : colors.primary,
    fontSize: 20,
  };
  return <div style={sectionTitle}>{text}</div>;
};



// WEBPACK FOOTER //
// ./src/components/common/SectionTitle.js